import React, { Component } from 'react';
import NavCollection from './NavCollection';
import FormatText from '../../../helpers/FormatTitle';
import { FrPickerChannel, FrPickerCollection, FrPickerCollectionNumbers, FrPickerCollectionNumbersCompare, FrPickerContainer } from './NavChannel.styled';
import { connect } from 'react-redux';
import { navigation_select_channel } from './../../../redux/reducers/navigationSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { COLOR } from '../../../theme/constants';

function mapStateToProps(state, ownProps) {
   return {
      SelectedChannel: state.navigation.selectedChannel,
      SelectedGeography: state.navigation.selectedGeography
   };
}

const mapDispatchToProps = (dispatch, ownProps) => {
   return {
      selectChannel: (channel, isMobile) => {
         const params = {
            channel: channel,
            isMobile: isMobile
         };
         dispatch(navigation_select_channel(params));
      }
   };
};

class NavChannelCompareCountries extends Component<
   {
      isMobile: boolean;
      collections: any[];
      selectChannel: any;
      SelectedChannel: string;
      SelectedGeography: string;
   },
   {}
> {
   constructor(props) {
      super(props);
      this.onClick = this.onClick.bind(this);
   }

   private onClick() {
      this.props.selectChannel('Compare Countries', this.props.isMobile);
   }

   public render() {
      const { collections, SelectedChannel, SelectedGeography } = this.props;

      const collectionsList = channels => {
         const channelList = channels.map((collection, index) => (
            <NavCollection key={index} name={collection.Name} channelTitle={'Compare Countries'} id={collection.Id} templateid={collection.TId} />
         ));

         return channelList;
      };

      const channels = collections.map((channel, index) => (
         <li key={index}>
            <a>{channel.TopicName}</a>
            <FrPickerCollectionNumbers>{collectionsList(channel.Collections)}</FrPickerCollectionNumbers>
         </li>
      ));

      const channelContainerStyles = () => {
         const isActive = SelectedChannel === 'Compare Countries' ? 'active' : '';
         return `${isActive}`;
      };

      return (
         <FrPickerContainer className={channelContainerStyles()}>
            <FrPickerChannel
               className={channelContainerStyles()}
               data-analytics={`Forecasts-Navigation-${FormatText(SelectedGeography)}-CompareCountries`}
               onClick={this.onClick}
            >
               <FontAwesomeIcon icon={channelContainerStyles() === 'active' ? faChevronUp : faChevronDown} width={14} color={COLOR.BLUE} />
               Compare Countries
            </FrPickerChannel>
            <FrPickerCollection className={channelContainerStyles()}>
               <FrPickerCollectionNumbersCompare>{channels}</FrPickerCollectionNumbersCompare>
            </FrPickerCollection>
         </FrPickerContainer>
      );
   }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavChannelCompareCountries);
